/* ChicChac — Snitch-style search: "TOP SEARCHES" chips in the predictive
   search modal, anchored below the search bar (above the live results).
   Horizon already renders a popup-below-the-bar with live product results +
   an empty-state product grid ("trending"); this adds curated top-search
   chips wired to the native search. */
(function () {
  'use strict';
  var TOP = ['Earrings', 'Pearls', 'Bracelets', 'Finger Rings', 'Neck Pieces', 'New Arrivals', 'Best Sellers', 'Gold'];

  function build(input) {
    var block = document.createElement('div');
    block.className = 'cc-topsearch';
    var head = document.createElement('div');
    head.className = 'cc-topsearch__head';
    head.textContent = 'Top searches';
    var row = document.createElement('div');
    row.className = 'cc-topsearch__chips';
    TOP.forEach(function (term) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'cc-topsearch__chip';
      chip.textContent = term;
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = term;
        input.focus();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        toggle(block, input);
      });
      row.appendChild(chip);
    });
    block.appendChild(head);
    block.appendChild(row);
    return block;
  }

  function toggle(block, input) {
    block.style.display = (input.value || '').trim() ? 'none' : 'block';
  }

  function inject(modal) {
    if (!modal) return;
    var form = modal.querySelector('.predictive-search-form');
    var input = modal.querySelector('#cmdk-input, input.search-input, input[type="search"]');
    if (!form || !input) return;
    if (modal.querySelector('.cc-topsearch')) return;      // already present — don't duplicate

    var block = build(input);
    form.parentNode.insertBefore(block, form.nextSibling);  // right below the search bar
    if (!input.__ccSearchBound) {
      input.__ccSearchBound = true;
      input.addEventListener('input', function () { toggle(block, input); });
    }
    toggle(block, input);
  }

  // Move the search icon into the right-hand actions group (next to account/cart).
  // In our forced bars-only "drawer" header, Horizon renders the drawer search on
  // the LEFT; relocate it so it sits with the account + cart icons on the right.
  function moveSearchRight() {
    var actions = document.querySelector('header-actions, .header-actions');
    if (!actions) return;
    var search = document.querySelector('.header .search-action--hidden-on-menu')
      || document.querySelector('.header .search-action');
    if (!search || search.__ccMoved) return;
    if (search.closest('header-actions, .header-actions')) { search.__ccMoved = true; return; }
    search.__ccMoved = true;
    search.classList.add('cc-search-in-actions');
    actions.insertBefore(search, actions.firstChild);
  }

  function boot() {
    inject(document.querySelector('#search-modal'));
    moveSearchRight();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // the modal/results hydrate + re-render; re-inject if our block gets wiped
  new MutationObserver(function () { boot(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
